import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FollowUpLineQuestion } from './FollowUpLineQuestion'

export const FollowUpListQuestion = ({ question, disabled, onAnswerChange }) => {
  const rdn = Math.random();
  const [checked, setChecked] = useState(question.answer.checked);

  return (
    <div className="o-follow-up-question o-follow-up-question--vertical">
      <div className="o-follow-up-question__line">
        <div className="o-follow-up-question__checkbox">
          <input
            id={`input-${rdn}`}
            className="o-follow-up-question__checkbox"
            type="checkbox"
            disabled={disabled}
            checked={checked}
            onChange={() => {
              setChecked(!checked);
              question.answer.checked = !checked;
              if (onAnswerChange) onAnswerChange();
            }}
          />
        </div>

        <div className="o-follow-up-question__label">
          <label htmlFor={`input-${rdn}`}>{question.title}</label>
        </div>
      </div>

      <div className="o-follow-up-question__field o-follow-up-question__field--full">
        {question.children.map((q, index) => <FollowUpLineQuestion key={index} question={q} disabled={disabled || !checked} onAnswerChange={onAnswerChange} />)}
      </div>
    </div >
  )
}

FollowUpListQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func,
}
